import { Schedule } from '@mui/icons-material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';
import { useUpdateScheduledShow } from '~/api/scheduled-show';
import { InlineEditTitle, Toolbar } from '~/components/toolbar';
import type { ScheduledShows__ScheduledShow as ScheduledShow } from '../../queries/queries.generated';

export interface ScheduleShowToolbarProps {
  actions?: ReactNode;
  scheduledShow: ScheduledShow;
}

export const ScheduleShowToolbar = ({ actions, scheduledShow }: ScheduleShowToolbarProps) => {
  const { t } = useTranslation();
  const [updateScheduledShow] = useUpdateScheduledShow();

  return (
    <Toolbar
      pageTitle={scheduledShow.name}
      actions={actions}
      titleIcon={<Schedule />}
      titleText={!scheduledShow.canUpdate.value && scheduledShow.name}
      titleEditor={
        scheduledShow.canUpdate.value && (
          <InlineEditTitle
            inputId={`scheduled-show-item-${scheduledShow.id}-name`}
            value={scheduledShow.name}
            update={(value) =>
              updateScheduledShow({
                variables: { id: scheduledShow.id, patch: { name: value.trim() } },
              })
            }
            tooltip={t('pages.schedules.detail.toolbar.edit_tooltip')}
            validationSchema={object({
              name: string().optional().trim(),
            })}
          />
        )
      }
    />
  );
};
